import { type MouseEvent, useState } from 'react';
import classNames from 'classnames';

import BettingActions from '~/services/actions/betting-actions';

import { type Bet } from '../types';

import styles from './styles/BetButton.module.css';
import { OddsButton, type OddsButtonProps } from './cxy';

export const BetButton = ({
  bet,
  className,
  onClick,
  withLabel = false,
  ...props
}: OddsButtonProps & {bet: Bet;withLabel?: boolean;}) => {
  const { bookieName } = props;
  const bettingActions = new BettingActions();

  const checkBetslipForBet = () => {
    const betsInBetslip = bettingActions.getBetslipCookieArray();
    return betsInBetslip.map((item) => item[0]).includes(bet.betId.toString());
  };

  const [isBetInBetslip, setIsBetInBetslip] = useState(checkBetslipForBet());

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    bettingActions.addOrRemoveFromBetslip(
      [{ betId: bet.betId }],
      [bet.betId],
      bookieName
    );

    setIsBetInBetslip(checkBetslipForBet());

    onClick?.(e);
  };

  const Button = () =>
  <OddsButton
    aria-pressed={isBetInBetslip}
    data-state={isBetInBetslip ? 'on' : 'off'}
    onClick={handleClick}
    selected={isBetInBetslip}
    {...props}
    className={classNames(
      styles.betButton,
      isBetInBetslip ? styles.isSelected : '',
      className
    )} />;



  return (
    <>
			{withLabel ?
      <div className={styles.betButtonWrapper}>
					<p>Best odds</p>
					<Button />
				</div> :

      <Button />
      }
		</>);

};